import style from './login.module.css'
import logo from "../../../img/logo.png"
import  FormCadastro  from './FormCadastro'
// import CadastroStep2 from './CadastroStep2';
import { useState } from 'react';
import { CadastroForm2 } from './FormCadastro';
import { CadastroForm3 } from './FormCadastro';
import { registarDiretorEscola } from '../../../firebase/CRUD';
import { useNavigate } from 'react-router-dom';
export  default function CadastroUser(){
    const [passoAtual, setPassoAtual] = useState(1);
    const [dadosEscola, setDadosEscola] = useState({});
    const [planoSelecionado,setPlanoSelecionado] = useState()
    const navigate = useNavigate()
    return(
        <div className={`${style.login}`} >
            {/* <img 
                src={logo}
                width={"10%"}
            >
            </img> */}
        <>
        {passoAtual === 1 && (
            <FormCadastro 
            avancarPara={(dados) => {
                setDadosEscola({diretor:{...dados.diretor},nomeIgreja:dados.igreja,idEscola:dados.idEscola});
                setPassoAtual(2);
            }} 
            />
        )}
        {passoAtual === 2 && (
            <CadastroForm2 
            nomeDiretor={dadosEscola.diretor.nome}
            voltar={() => setPassoAtual(1)}
            avancarParaPagamento={(plano) =>
                {
                    setPlanoSelecionado(plano)
                    setPassoAtual(3)
                }
            }
            />
        )}
        {passoAtual === 3 && (
            <CadastroForm3 
            nomeDiretor={dadosEscola.diretor.nome}
            planoEscolhido={planoSelecionado}
            voltar={() => setPassoAtual(2)}
            dadosCadastro={dadosEscola}
            avancarParaPagamento={(plano) =>
                {
                    setPlanoSelecionado(plano)
                    setPassoAtual(3)
                }
            }/>
        )}
        </>
        </div>
    )
}